import axios from "axios";

export const updateEnLigne = async (apiUrl, id, checked) => {
  const newValue = checked ? 1 : 0;

  try {
    await axios.post(`${apiUrl}IHM/api/postUpdate/updateDevisEnLigne.php`, {
      id,
      enLigne: newValue,
    });

    return newValue;
  } catch (e) {
    console.error("Erreur updateEnLigne :", e);
    throw e;
  }
};
